import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { useLiveNotification } from "../../contexts/RealtimeContext";

/**
 * Hook ligero que obtiene los contadores para los badges del menú lateral.
 * Se refresca al montar, cada 60 segundos (red de seguridad) y al instante
 * cuando llega una notificación en vivo relevante (solicitudes/pagos).
 */
export function useNavBadges() {
  const [badges, setBadges] = useState({ applications: 0, payments: 0, incidents: 0 });

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const { data } = await api.get("/nav-badges");
        if (alive) setBadges(data);
      } catch {
        /* silencioso: los badges no son críticos */
      }
    };
    load();
    const id = setInterval(load, 60000);
    return () => {
      alive = false;
      clearInterval(id);
    };
  }, []);

  useLiveNotification(async () => {
    try {
      const { data } = await api.get("/nav-badges");
      setBadges(data);
    } catch {
      /* silencioso */
    }
  });

  return badges;
}
